import { useEffect, useState } from "react";
import { api, formatMoney, formatDate, todayISO } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X, Play, Repeat, Pause } from "lucide-react";

export default function Recurring() {
  const [items, setItems] = useState([]);
  const [banks, setBanks] = useState([]);
  const [cari, setCari] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    title: "", type: "expense", amount: "", currency: "TRY", category: "",
    description: "", bank_account_id: "", cari_id: "",
    frequency: "monthly", day_of_month: 1, day_of_week: 1,
    next_run: todayISO(), active: true,
  });

  const load = async () => {
    const [r, b, c] = await Promise.all([api.get("/recurring"), api.get("/bank-accounts"), api.get("/cari")]);
    setItems(r.data); setBanks(b.data); setCari(c.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/recurring", {
        ...form,
        amount: Number(form.amount),
        day_of_month: Number(form.day_of_month),
        day_of_week: Number(form.day_of_week),
      });
      toast.success("Şablon eklendi");
      setOpen(false);
      setForm({ ...form, title: "", amount: "", category: "", description: "" });
      load();
    } catch { toast.error("Kayıt başarısız"); }
  };
  const apply = async (id) => {
    try {
      await api.post(`/recurring/${id}/apply`);
      toast.success("İşlem oluşturuldu");
      load();
    } catch { toast.error("Uygulama başarısız"); }
  };
  const toggle = async (r) => { await api.put(`/recurring/${r.id}`, { active: !r.active }); load(); };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/recurring/${id}`); load(); };

  const freqLabel = (f) => ({ daily: "Günlük", weekly: "Haftalık", monthly: "Aylık", yearly: "Yıllık" }[f] || f);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-slate-500 font-bold">Otomasyon</div>
          <h1 className="font-display text-4xl font-extrabold text-slate-900 mt-1">Tekrarlayan Kayıtlar</h1>
          <p className="text-slate-500 mt-1 text-sm">Kira, maaş, abonelik gibi düzenli işlemler için şablonlar. Her gün 06:00 UTC'de otomatik uygulanır.</p>
        </div>
        <button data-testid="add-recurring" onClick={() => setOpen(true)} className="flex items-center gap-2 px-5 py-3 rounded-xl bg-[#1E2A9C] text-white font-bold hover:bg-[#121A68] shadow-lg shadow-[#1E2A9C]/20">
          <Plus className="w-4 h-4" /> Yeni Şablon
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 uppercase text-[10px] tracking-widest">
            <tr>
              <th className="text-left px-6 py-3 font-bold">Durum</th>
              <th className="text-left px-6 py-3 font-bold">Başlık</th>
              <th className="text-left px-6 py-3 font-bold">Tip</th>
              <th className="text-left px-6 py-3 font-bold">Sıklık</th>
              <th className="text-left px-6 py-3 font-bold">Sıradaki</th>
              <th className="text-right px-6 py-3 font-bold">Tutar</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="text-center py-16 text-slate-400">Henüz şablon yok</td></tr>}
            {items.map(r => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50/50">
                <td className="px-6 py-4">
                  <button data-testid={`toggle-${r.id}`} onClick={() => toggle(r)} className={`px-2.5 py-1 rounded-md text-xs font-bold ${r.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                    {r.active ? "Aktif" : "Pasif"}
                  </button>
                </td>
                <td className="px-6 py-4 font-semibold text-slate-800">{r.title}</td>
                <td className="px-6 py-4">
                  <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${r.type === "income" ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>
                    {r.type === "income" ? "Gelir" : "Gider"}
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-600"><Repeat className="w-3.5 h-3.5 inline mr-1 text-slate-400" />{freqLabel(r.frequency)}</td>
                <td className="px-6 py-4 font-mono-num text-slate-700">{formatDate(r.next_run)}</td>
                <td className={`px-6 py-4 text-right font-mono-num font-bold ${r.type === "income" ? "text-emerald-600" : "text-rose-600"}`}>{formatMoney(r.amount, r.currency)}</td>
                <td className="px-6 py-4 text-right">
                  <div className="flex justify-end gap-2">
                    <button data-testid={`apply-${r.id}`} onClick={() => apply(r.id)} className="p-1.5 rounded-lg bg-[#1E2A9C]/10 text-[#1E2A9C] hover:bg-[#1E2A9C] hover:text-white transition" title="Şimdi Uygula"><Play className="w-3.5 h-3.5" /></button>
                    <button data-testid={`del-rec-${r.id}`} onClick={() => del(r.id)} className="p-1.5 text-slate-400 hover:text-rose-600"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 grid place-items-center p-4">
          <form onSubmit={submit} className="bg-white rounded-2xl w-full max-w-xl p-8 relative">
            <button type="button" onClick={() => setOpen(false)} className="absolute top-4 right-4"><X className="w-5 h-5" /></button>
            <div className="font-display text-2xl font-extrabold mb-6">Yeni Tekrarlayan Kayıt</div>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Tip</label>
                <select data-testid="rec-type" value={form.type} onChange={(e) => setForm({...form, type: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="expense">Gider</option><option value="income">Gelir</option>
                </select></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Sıklık</label>
                <select data-testid="rec-freq" value={form.frequency} onChange={(e) => setForm({...form, frequency: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="daily">Günlük</option><option value="weekly">Haftalık</option>
                  <option value="monthly">Aylık</option><option value="yearly">Yıllık</option>
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Başlık</label>
                <input required data-testid="rec-title" value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} placeholder="Ofis Kirası, Personel Maaşı..." className="w-full mt-1 px-3 py-2 border rounded-lg" /></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Tutar</label>
                <input required type="number" step="0.01" data-testid="rec-amount" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg font-mono-num" /></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Para Birimi</label>
                <select data-testid="rec-currency" value={form.currency} onChange={(e) => setForm({...form, currency: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  {["TRY","USD","EUR"].map(c => <option key={c} value={c}>{c}</option>)}
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Kategori</label>
                <input required data-testid="rec-category" value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg" /></div>
              {form.frequency === "monthly" && (
                <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Ayın Günü (1-28)</label>
                  <input type="number" min="1" max="28" data-testid="rec-dom" value={form.day_of_month} onChange={(e) => setForm({...form, day_of_month: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg font-mono-num" /></div>
              )}
              {form.frequency === "weekly" && (
                <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Haftanın Günü</label>
                  <select data-testid="rec-dow" value={form.day_of_week} onChange={(e) => setForm({...form, day_of_week: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                    {["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"].map((d, i) => <option key={d} value={i+1}>{d}</option>)}
                  </select></div>
              )}
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Başlangıç</label>
                <input type="date" data-testid="rec-next" value={form.next_run} onChange={(e) => setForm({...form, next_run: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg" /></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Banka Hesabı</label>
                <select data-testid="rec-bank" value={form.bank_account_id} onChange={(e) => setForm({...form, bank_account_id: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="">-</option>
                  {banks.filter(b => b.currency === form.currency).map(b => <option key={b.id} value={b.id}>{b.bank_name} ({b.name})</option>)}
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Cari</label>
                <select data-testid="rec-cari" value={form.cari_id} onChange={(e) => setForm({...form, cari_id: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="">-</option>
                  {cari.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Açıklama</label>
                <textarea data-testid="rec-desc" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} rows="2" className="w-full mt-1 px-3 py-2 border rounded-lg"></textarea></div>
            </div>
            <button data-testid="rec-submit" className="w-full mt-6 py-3 bg-[#1E2A9C] text-white rounded-lg font-bold">Kaydet</button>
          </form>
        </div>
      )}
    </div>
  );
}
